package com.essntl.features.itinerary.ui.itinerary_overview

sealed interface ItineraryOverviewEvent {
    data class GetItinerary(val id: String) : ItineraryOverviewEvent

    data object ClearState : ItineraryOverviewEvent
}